import { LuUsers } from 'react-icons/lu';

import type { NavItem } from 'src/shared/components/shell/navTypes';

export const clientsNav: NavItem[] = [
  { icon: LuUsers, label: 'Clientas', to: '/clientes', placement: 'primary' },
];
